const
    abs = Math.abs,

    min = Math.min,

    max = Math.max,

    floor = Math.floor,

    ceil = Math.ceil,

    round = Math.round,

    pow = Math.pow,

    clamp = (value, minimum, maximum) => (
        min(
            max(value, minimum),
            maximum));

export {
    abs,
    min,
    max,
    floor,
    ceil,
    round,
    pow,
    clamp
};
